import { useState, useEffect } from "react";

export const LinearLoader = ({
  progress: propProgress = null, // If null, the loader will animate automatically
  containerStyle = {},
  progressBarStyle = {},
  intervalTime = 200,
  increment = 5,
  loop = false, // Enables looping mode
}) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (propProgress !== null) {
      setProgress(propProgress);
      return;
    }

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          if (loop) {
            return 0; // Restart progress if looping is enabled
          }
          clearInterval(interval); // Stop when progress reaches 100%
          return 100;
        }
        return prev + increment; // Increment progress
      });
    }, intervalTime);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [propProgress, intervalTime, increment, loop]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1050,
        ...containerStyle,
      }}
    >
      <div className="progress" style={{ height: "5px", ...containerStyle }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{
            width: `${progress}%`,
            transition: "width 0.2s ease-in-out",
            ...progressBarStyle,
          }}
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
};
